import { useState, useEffect, useContext } from 'react';

import { getLastTimeUserLoginMobile } from '../services';
import GlobalNavContext from '../context/globalNavContext';

const useIsAppMobileUser = () => {
  const [isAppMobileUserNotActive, setIsAppMobileUserNotActive] =
    useState(false);
  const { env } = useContext(GlobalNavContext);

  useEffect(() => {
    (async () => {
      const response = await getLastTimeUserLoginMobile(env);
      const lastAppUsage = response?.statistics?.lastAppUsage;
      if (!lastAppUsage) {
        setIsAppMobileUserNotActive(true);
        return;
      }
      const userLastLogin = new Date(lastAppUsage).getTime();
      const lastSixMonths = new Date();
      lastSixMonths.setMonth(lastSixMonths.getMonth() - 6);
      setIsAppMobileUserNotActive(lastSixMonths > userLastLogin);
    })();
  }, [env]);

  return isAppMobileUserNotActive;
};

export default useIsAppMobileUser;
